<template>
  <div>
    <h2>Teams</h2>
    <ul
      v-for="team in user.teams"
      :key="team.code"
    >
      <router-link :to="{ name:'manage-accounts-account', params: { accountId: team.account.id } }">
        {{ team.name }} - {{ team.account.name }}
      </router-link>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  }
}
</script>
